import { QueryCache, QueryClient } from '@tanstack/react-query';

import { ApiError } from 'generated/core/ApiError';

import { reportError } from 'shared/utils/report_error';

/**
 * Singleton QueryClient instance for the application.
 * This allows access to the QueryClient both inside and outside React components.
 */
export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      if (error instanceof ApiError) return;
      reportError(error, { queryKey: query.queryKey });
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
    },
  },
});

/**
 * Helper function to invalidate all count queries at once
 */
export const invalidateAllCountQueries = () => {
  queryClient.invalidateQueries({ queryKey: ['draftsCount'] });
  queryClient.invalidateQueries({ queryKey: ['triageCount'] });
  queryClient.invalidateQueries({ queryKey: ['waitingCount'] });
};
